import { HttpEvent, HttpEventType, HttpHeaders, HttpRequest } from '@angular/common/http';
import { ApplicationRef, Injectable } from '@angular/core';
import { Observable, Subscription, throwError as observableThrowError } from 'rxjs';
import { catchError, last, map, tap } from 'rxjs/operators';

import { ApiGatewayService } from './api-gateway.service';
import { SafeLogger } from '../utils/safe-logger';



@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(
    private apiGatewayService: ApiGatewayService,
  ) {
  }

  getPresignedURL = (file: any): Observable<any> => {
    return this.apiGatewayService.getPresignedURL(file);
  }

  uploadFileWithPresignedUrl = (baseUrl: string, file: File, filePlaceholder: any): Observable<any> => {
    const blobData = new Blob([file], {type: file.type});

    const headers = new HttpHeaders()
      .set('Content-Disposition', `attachment; filename=${file.name}`)
      .set('x-amz-meta-options', filePlaceholder.metadata);

    const req = new HttpRequest('PUT', `${baseUrl}`, blobData, {headers: headers, reportProgress: true});
    return this.apiGatewayService.request(req)
    .pipe(
      last(),
      catchError((response): Observable<Error> => {
        const alertMessage = 'There was a problem uploading the file. Please try again.';
        if (response.status === 409 && response.error.exception === "edu.wgu.dmclamav.exception.VirusFoundException") {
          filePlaceholder.virusDetected = true;
          filePlaceholder.actionStatus = null;
        } else {
          SafeLogger.log('There was a problem uploading the file. ', response.json ? response.json() : response);
          filePlaceholder.actionStatus = 'ERROR-UPLOADING';
        }
        return observableThrowError(
          new Error(`${ response.status } ${ response.statusText }`)
        );
      })
    );
  }
}
